import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip_Finding_Base } from './Tooltip_Finding_Base.js';
import { _className, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Tooltip_Finding_Textual.scss';
export class Tooltip_Finding_Textual extends Tooltip_Finding_Base {
    //######################### Render #########################
    render_Content = () => {
        return _jsxs(_Fragment, { children: [this.render_Source(), this.render_Divider(), _jsx(LL_V_L, { className: 'finding-tooltip__content textual', children: this.render_Results() })] });
    };
    render_Results = () => {
        return _jsxs(LL_V_L, { className: 'textual-results', children: [_jsx("div", { className: 'textual-results__section-title', children: "Results:" }), this.state.data.results.map(this.render_Result)] });
    };
    render_Result = (result, index) => {
        const timestamp = this.resolveTimestamp(result);
        const value = this.resolveValue(result);
        const className = _className('textual-result', !result.currentEncounter && 'prev-encounter');
        return _jsxs(LL_V_L, { className: className, children: [_jsx("div", { className: 'textual-result__timestamp', children: timestamp }), _jsx("div", { className: 'textual-result__value', children: value })] }, index);
    };
}
//# sourceMappingURL=Tooltip_Finding_Textual.js.map